module.exports = __webpack_public_path__ + "img/1461731369.802114b0.jpg";